export default "__VITE_PUBLIC_ASSET__1048ecee__"